import React, { useState, useEffect } from 'react';
import './TableOne.css';
const TableOne = (props) => {
    const [rows, setRows] = useState([]);
    const [sortConfig, setSortConfig] = useState(null);
    useEffect(() => {
        setRows(props.rows);
    }, [props.rows]);
    const onHeaderClick = (column) => {
        let direction = 'asc';
        if (sortConfig && sortConfig.column === column && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        // Sorts the rows based on the specified column and direction
        const sortedData = [...rows].sort((rowA, rowB) => {
            const valueA = rowA[column];
            const valueB = rowB[column];
            if (valueA < valueB) {
                return direction === 'asc' ? -1 : 1;
            }
            if (valueA > valueB) {
                return direction === 'asc' ? 1 : -1;
            }
            return 0;
        });
        setRows(sortedData);
        setSortConfig({ column, direction });
    };
    return (React.createElement("div", { style: { minWidth: '1000px', overflowX: 'hidden', ...props.style } },
        React.createElement("table", { className: "styled-table" },
            React.createElement("thead", null,
                React.createElement("tr", { style: { cursor: 'pointer' } }, props.headers.map((header) => (React.createElement("th", { key: header.key, onClick: () => onHeaderClick(header.key) },
                    React.createElement("span", null,
                        header.value,
                        " ",
                        sortConfig?.column === header.key && (sortConfig?.direction === 'asc' ? '▲' : '▼'))))))),
            React.createElement("tbody", null, rows.map((row) => (React.createElement("tr", { key: row.id, className: `${row.id !== undefined && row.id === props.selectedRow ? 'selected-row' : ''}`, style: {
                    cursor: props.cursorStyle ? props.cursorStyle : 'pointer',
                } }, Object.keys(row).map((key) => {
                if (props.headers.some((header) => header.key === key) &&
                    key !== 'id' &&
                    !props.ignoreKeyFilters?.includes(key)) {
                    const hiddenActor = key === 'actor' && row['actor']?.props;
                    return (React.createElement("td", { onClick: () => props.onClick && !hiddenActor && props.onClick(row[props.onClickValue ?? 'id']), key: key }, row[key]));
                }
                else {
                    return null;
                }
            }))))))));
};
export default TableOne;
